module.exports = __webpack_public_path__ + "img/Group 18.3194b02c.svg";